import { useState, useEffect } from "react";
import "./ViewReportsPageCSS/ViewReportForm.css";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { getViewReport } from "../../api/api";
import { parseBillId } from "../../utils/helper";
import toast from "react-hot-toast";
import ShowReport from "./ShowReport";
import CustomLoader from "../../common/loader/CustomLoader";
import helpImage from "../../Assets/RB_Pay (1).png";
import { useNavigate } from "react-router-dom";

export default function ViewReportFormSection() {
  const [btnName, setBtnName] = useState("Find Report");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1250) {
        setBtnName("Find");
      } else {
        setBtnName("Find Report");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const [formData, setFormData] = useState({
    char: "",
    digit1: "",
    digit2: "",
    surname: "",
  });
  const [errors, setErrors] = useState({});
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const isFormValid = () => {
    return (
      formData.char &&
      formData.digit1 &&
      formData.digit2 &&
      formData.surname.trim() &&
      !errors.char &&
      !errors.digit1 &&
      !errors.digit2 &&
      !errors.surname
    );
  };

  const handleCharChange = (e, nextId) => {
    const value = e.target.value.replace(/[^a-zA-Z]/g, "").toUpperCase();
    setFormData((prev) => ({ ...prev, char: value }));
    if (value.length === 2) document.getElementById(nextId)?.focus();
  };

  const handleDigitChange = (e, key, nextId, maxLength) => {
    let value = e.target.value.replace(/\D/g, "");

    if (key === "digit1" && value.length === 2) {
  const num = Number(value);

  if (num < 1 || num > 31) {
    toast.error("Invalid! Please enter a value between 01 and 31.");
    value = "";
  }
}

    

    setFormData((prev) => ({ ...prev, [key]: value }));

    if (value.length === maxLength && !(key === "digit1" && value === "")) {
      document.getElementById(nextId)?.focus();
    }
  };

  const handleSurnameChange = (e) => {
    setFormData((prev) => ({ ...prev, surname: e.target.value }));
  };

  const handleResetForm = () => {
    setFormData({
      char: "",
      digit1: "",
      digit2: "",
      surname: "",
    });
    document.getElementById("char")?.focus();
  };

  const handleNeedhelp = (e) => {
    setShowPopup(true);
  };

  const handleBlur = (field, value) => {
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "Required" }));
    } else {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleGoBack = () => {
    setReports([]);
    handleResetForm();
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // const handleFindReports = async () => {
  //   const billId = `${formData.char}${formData.digit1}-${formData.digit2}`;

  //   const payload = {
  //     RBAuthKey: "RBDWAh!Q1s74e",
  //     Bill_id: billId,
  //     FYear: parseBillId(billId)?.financialYear || "",
  //     sur_name: formData.surname.trim(),
  //   };

  //   try {
  //     setLoading(true); 
  //     const response = await getViewReport(payload);
  //     console.log("View Report Response:", response);

  //     const reports = response?.data?.data;

  //     if (Array.isArray(reports) && reports.length > 0) {
  //       setReports(reports);
  //     } else {
  //       const msg =
  //         response?.data?.message?.toString() ||
  //         "No reports found for given details!";
  //       toast.error(msg);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching reports:", error);
  //     toast.error("Something went wrong. Please try again later!");
  //   } finally {
  //     setLoading(false); 
  //   }
  // };



  const handleFindReports = () => {
  const billId = `${formData.char}${formData.digit1}-${formData.digit2}`;
  const lastName = formData.surname.trim().toUpperCase();

  const url = `/searchreport?billid=${encodeURIComponent(
    billId
  )}&lastname=${encodeURIComponent(lastName)}`;

  // 🔹 open in same tab
  navigate(url);

  // 🔹 OR open in new tab (use this instead if required)
  // window.open(url, "_blank");
};


  return (
    <>
      {/* ✅ Loader Overlay */}
      {loading && (
        <div>
          <CustomLoader />
        </div>
      )}

      {/* {reports.length > 0 ? (
        <ShowReport reports={reports} onBack={handleGoBack} />
      ) : ( */}
        <div className="report-form-container">
          <div className="reportTextSection">
            <h3 className="form-heading">Your Acc No.</h3>
            <h5 onClick={handleNeedhelp} style={{ cursor: "pointer" }}>
              <IoMdHelpCircleOutline size={25} />
              <i>Need Help?</i>
            </h5>
          </div>

          <div className="form-row-report">

            <div className="credentials-section">
              {/* === Inputs === */}
              <div className="input-wrapper te">
                <label htmlFor="char">
                  Char<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="char"
                  type="text"
                  maxLength={2}
                  placeholder="Enter Char"
                  className="input-field smallField"
                  value={formData.char}
                  autoComplete="off"
                  onChange={(e) => handleCharChange(e, "digit1")}
                  onBlur={(e) => handleBlur("char", e.target.value)}
                />
                <div className="error-text-viewreport">
                  {errors.char && errors.char}
                </div>

              </div>

              <div className="input-wrapper te">
                <label htmlFor="digit1">
                  Digit<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="digit1"
                  type="text"
                  name="billno"
                  maxLength={2}
                  placeholder="Enter 2 Digit"
                  className="input-field smallField"
                  value={formData.digit1}
                  autoComplete="off"
                  onChange={(e) => handleDigitChange(e, "digit1", "digit2", 2)}
                  onBlur={(e) => handleBlur("digit1", e.target.value)}
                />
                <div className="error-text-viewreport">
                  {errors.digit1 && errors.digit1}
                </div>
              </div>

              <div className="input-wrapper te">
                <label htmlFor="digit2">
                  Digits<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="digit2"
                  type="text"
                  maxLength={4}
                  placeholder="Enter 4 Digits"
                  className="input-field smallField"
                  value={formData.digit2}
                  autoComplete="off"
                  onChange={(e) => handleDigitChange(e, "digit2", "surname", 4)}
                  onBlur={(e) => handleBlur("digit2", e.target.value)}
                />
                <div className="error-text-viewreport">
                  {errors.digit2 && errors.digit2}
                </div>
              </div>

              <div className="input-wrapper te">
                <label htmlFor="surname">
                  Surname<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="surname"
                  type="text"
                  placeholder="Enter Surname"
                  className="input-field surname_field"
                  value={formData.surname}
                  onChange={handleSurnameChange}
                  onBlur={(e) => handleBlur("surname", e.target.value)}
                  autoComplete="off"
                />
                <div className="error-text-viewreport">
                  {errors.surname && errors.surname}
                </div>
              </div>
            </div>

            <div className="lowerSectionButton viewReportBtnSection">
              <button
                className="rbdButton reportBtn"
                type="button"
                onClick={handleFindReports}
                disabled={!isFormValid() || loading}
              >
                <span className="btn-text">{btnName}</span>
              </button>
              <button
                className="rbdButton reset-Btn reportBtn"
                type="button"
                onClick={handleResetForm}
              >
                <span className="btn-text">Reset</span>
              </button>
            </div>
          </div>
        </div>
      {/* )} */}

      {showPopup && (
        <div className="help-overlay" onClick={closePopup}>
          <div className="help-popup" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closePopup}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0,0,0,0.7)",
                color: "#fff",
                border: "none",
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                fontSize: "22px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
              }}
            >
              ×
            </button>

            <img
              src={helpImage}
              alt="Help"
              style={{ width: "100%", borderRadius: "10px", display: "block" }}
            />
          </div>
        </div>
      )}
    </>
  );
}
